export class ImportSaveMappingParameter {
  value: string;
  selectedIntectColumnValue: string;
  selectedColumnTypeValue: string;
  selectedColumnTypeKey: string;
  public toString(): string {
    let key = '';
    if (this.isAmount() && this.selectedColumnTypeValue && this.selectedColumnTypeValue.toString() !== '-1') {
      key = this.selectedColumnTypeValue;
    }

    if (this.selectedIntectColumnValue && this.selectedIntectColumnValue.toString() !== '-1') {
      if (this.isIdentifyingColumn()) {
        key = ';' + this.selectedIntectColumnValue;
      } else {
        key =
          this.selectedIntectColumnValue +
          (this.selectedColumnTypeKey && this.selectedColumnTypeKey.toString() !== '-1'
            ? ';' + this.selectedColumnTypeKey
            : '');
      }
    }

    if (key) {
      return `{"Key":"${key}","Value":"${this.value}"}`;
    }

    return '';
  }

  private isAmount(): boolean {
    return this.selectedColumnTypeValue === '1';
  }

  private isUnit(): boolean {
    return this.selectedColumnTypeValue === '2';
  }

  private isIdentifyingColumn(): boolean {
    return (
      this.selectedIntectColumnValue === 'cpr' ||
      this.selectedIntectColumnValue === 'reference' ||
      this.selectedIntectColumnValue === 'navn' ||
      this.selectedIntectColumnValue === 'id'
    );
  }
}
